var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "handle-coupon",
      attrs: { "element-loading-text": _vm.loadingText },
    },
    [
      _c(
        "div",
        { staticClass: "handle-coupon-body" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.couponRules,
                "label-width": "150px",
                size: "small",
              },
            },
            [
              _c(
                "div",
                { staticClass: "step-indicator mb20" },
                _vm._l(_vm.steps, function (s, idx) {
                  return _c(
                    "div",
                    {
                      key: idx,
                      class: ["step-item", { active: _vm.currentStep === idx }],
                      on: {
                        click: function ($event) {
                          _vm.currentStep = idx
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "step-index" }, [
                        _vm._v(_vm._s(idx + 1)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step-title" }, [
                        _vm._v(_vm._s(s)),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 0,
                      expression: "currentStep === 0",
                    },
                  ],
                  staticClass: "form-card",
                },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _c("i", { staticClass: "el-icon-document" }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("基本信息")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-divider" }),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "营销方：", prop: "marketingParty" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.form.marketingParty,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "marketingParty", $$v)
                            },
                            expression: "form.marketingParty",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("平台"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("入驻商户"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠券名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: true,
                          placeholder: "请输入优惠券名称",
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否用于积分兑换：",
                            prop: "isIntegralExchange",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.isIntegralExchangeLocked },
                              on: { change: _vm.handleIsPointsExchangeChange },
                              model: {
                                value: _vm.form.isIntegralExchange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isIntegralExchange", $$v)
                                },
                                expression: "form.isIntegralExchange",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.isIntegralExchange === 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "form-tip",
                                  staticStyle: { "margin-top": "8px" },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-info" }),
                                  _vm._v(
                                    " 勾选是之后，以下不同页面未关联字段不展示\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否与新人价互斥：",
                            prop: "excludeNewcomerPrice",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.excludeNewcomerPrice,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "excludeNewcomerPrice",
                                    $$v
                                  )
                                },
                                expression: "form.excludeNewcomerPrice",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "券类型：", prop: "voucherType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled: _vm.form.isIntegralExchange === 1,
                              },
                              model: {
                                value: _vm.form.voucherType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "voucherType", $$v)
                                },
                                expression: "form.voucherType",
                              },
                            },
                            _vm._l(_vm.voucherTypeOptions, function (item) {
                              return _c(
                                "el-radio",
                                { key: item.code, attrs: { label: item.code } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.value) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.isIntegralExchange === 1
                            ? _c(
                                "span",
                                {
                                  staticClass: "form-tip",
                                  staticStyle: { "margin-left": "8px" },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-info" }),
                                  _vm._v(" 积分兑换仅支持优惠券"),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "内部备注：", prop: "internalRemark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入内部备注（仅管理后台可见）",
                          type: "textarea",
                          rows: 3,
                        },
                        model: {
                          value: _vm.form.internalRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "internalRemark", $$v)
                          },
                          expression: "form.internalRemark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "领券时间：", prop: "receiveTime" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "coupon-date-picker",
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": _vm.timeFormat,
                              "default-time": _vm.dateRangeDefaultTime,
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.receiveTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "receiveTime", $$v)
                              },
                              expression: "form.receiveTime",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "券有效期：", prop: "validityType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "validity-radio-group",
                          model: {
                            value: _vm.form.validityType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "validityType", $$v)
                            },
                            expression: "form.validityType",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticClass: "validity-option",
                              attrs: {
                                label: 0,
                                disabled: _vm.isReceivedCouponLocked,
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "validity-option-text" },
                                [_vm._v("指定时间段")]
                              ),
                              _vm._v(" "),
                              _vm.form.validityType == 0
                                ? _c("el-date-picker", {
                                    staticClass:
                                      "coupon-date-picker validity-date-picker",
                                    attrs: {
                                      disabled: _vm.isReceivedCouponLocked,
                                      type: "datetimerange",
                                      "range-separator": "至",
                                      "start-placeholder": "开始日期",
                                      "end-placeholder": "结束日期",
                                      "value-format": _vm.timeFormat,
                                      "default-time": _vm.dateRangeDefaultTime,
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.lifespanTime,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "lifespanTime", $$v)
                                      },
                                      expression: "form.lifespanTime",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "validity-option-divider" }),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              staticClass: "validity-option",
                              attrs: {
                                label: 1,
                                disabled: _vm.isReceivedCouponLocked,
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "validity-option-text" },
                                [_vm._v("领取后")]
                              ),
                              _vm._v(" "),
                              _vm.form.validityType == 1
                                ? _c("el-input-number", {
                                    staticClass: "validity-days-input",
                                    attrs: {
                                      disabled: _vm.isReceivedCouponLocked,
                                      min: 1,
                                      "controls-position": "right",
                                    },
                                    model: {
                                      value: _vm.form.validityDays,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "validityDays", $$v)
                                      },
                                      expression: "form.validityDays",
                                    },
                                  })
                                : _c(
                                    "span",
                                    {
                                      staticClass: "validity-days-placeholder",
                                    },
                                    [_vm._v("指定")]
                                  ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "validity-option-text" },
                                [_vm._v("天数")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠方式：", prop: "couponType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "discount-types",
                          attrs: {
                            disabled:
                              _vm.form.isIntegralExchange === 1 ||
                              _vm.isReceivedCouponLocked,
                          },
                          on: { change: _vm.changeCouponType },
                          model: {
                            value: _vm.form.couponType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "couponType", $$v)
                            },
                            expression: "form.couponType",
                          },
                        },
                        _vm._l(
                          _vm.commonData.discountMethodsEnum,
                          function (rad) {
                            return _c(
                              "el-radio",
                              {
                                key: rad.id,
                                staticClass: "discount-type-option",
                                attrs: { label: rad.id },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(rad.name) +
                                    "\n            "
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.isIntegralExchange === 1
                        ? _c(
                            "span",
                            {
                              staticClass: "form-tip",
                              staticStyle: { "margin-left": "8px" },
                            },
                            [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(" 积分兑换仅支持满减券"),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠信息：", prop: "couponDiscount" } },
                    [
                      _c(
                        "div",
                        { staticClass: "discount-info-container" },
                        _vm._l(_vm.form.couponDiscount, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "coupon-info-item" },
                            [
                              _c("span", { staticClass: "discount-label" }, [
                                _vm._v("满"),
                              ]),
                              _vm._v(" "),
                              _vm.form.couponType !== 2
                                ? _c("el-input-number", {
                                    staticClass: "discount-input",
                                    attrs: {
                                      disabled: _vm.isReceivedCouponLocked,
                                      min: 0,
                                      placeholder: "请输入",
                                      controls: false,
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.validateDiscountRule(
                                          item,
                                          index
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.threshold,
                                      callback: function ($$v) {
                                        _vm.$set(item, "threshold", $$v)
                                      },
                                      expression: "item.threshold",
                                    },
                                  })
                                : _c("el-input-number", {
                                    staticClass: "discount-input",
                                    attrs: {
                                      disabled: _vm.isReceivedCouponLocked,
                                      min: 1,
                                      max: 9999,
                                      precision: 0,
                                      placeholder: "请输入",
                                      controls: false,
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.validateDiscountRule(
                                          item,
                                          index
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.threshold,
                                      callback: function ($$v) {
                                        _vm.$set(item, "threshold", $$v)
                                      },
                                      expression: "item.threshold",
                                    },
                                  }),
                              _vm._v(" "),
                              _c("span", { staticClass: "discount-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.form.couponType == 2
                                      ? "件，打"
                                      : "元，减"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("el-input-number", {
                                staticClass: "discount-input",
                                attrs: {
                                  disabled: _vm.isReceivedCouponLocked,
                                  min: 0,
                                  max:
                                    _vm.form.couponType === 2 ? 10 : undefined,
                                  placeholder: "请输入",
                                  controls: false,
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.validateDiscountRule(item, index)
                                  },
                                },
                                model: {
                                  value: item.discount,
                                  callback: function ($$v) {
                                    _vm.$set(item, "discount", $$v)
                                  },
                                  expression: "item.discount",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "discount-label" }, [
                                _vm._v(
                                  _vm._s(_vm.form.couponType == 2 ? "折" : "元")
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "coupon-info-actions" },
                                [
                                  index === 0
                                    ? _c("el-button", {
                                        staticClass: "action-btn add-btn",
                                        attrs: {
                                          disabled: _vm.isReceivedCouponLocked,
                                          type: "primary",
                                          icon: "el-icon-plus",
                                          size: "mini",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeCouponDiscountInfo(
                                              "add"
                                            )
                                          },
                                        },
                                      })
                                    : _c("el-button", {
                                        staticClass: "action-btn remove-btn",
                                        attrs: {
                                          disabled: _vm.isReceivedCouponLocked,
                                          type: "danger",
                                          icon: "el-icon-delete",
                                          size: "mini",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeCouponDiscountInfo(
                                              index
                                            )
                                          },
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "最高优惠：", prop: "maxDiscount" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          disabled: _vm.isReceivedCouponLocked,
                          min: 0,
                          placeholder: "请输入最高优惠金额",
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.form.maxDiscount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "maxDiscount", $$v)
                          },
                          expression: "form.maxDiscount",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "input-suffix" }, [
                        _vm._v("元"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放数量：", prop: "totalQuantity" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          min: 0,
                          placeholder: "请输入发放总数量",
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.form.totalQuantity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalQuantity", $$v)
                          },
                          expression: "form.totalQuantity",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "input-suffix" }, [
                        _vm._v("张"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 1,
                      expression: "currentStep === 1",
                    },
                  ],
                  staticClass: "form-card",
                },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _c("i", { staticClass: "el-icon-setting" }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("其他信息")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-divider" }),
                  _vm._v(" "),
                  _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "领用规则：", prop: "limitType" } },
                        [
                          _c(
                            "div",
                            { staticClass: "limit-rule-container" },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.limitType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "limitType", $$v)
                                    },
                                    expression: "form.limitType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "limit-radio",
                                      attrs: { label: 1 },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "limit-label" },
                                        [_vm._v("每人限领")]
                                      ),
                                      _vm._v(" "),
                                      _c("el-input-number", {
                                        staticClass: "limit-input",
                                        attrs: {
                                          min: 1,
                                          max: 999,
                                          size: "small",
                                          "controls-position": "right",
                                        },
                                        model: {
                                          value: _vm.form.limitCount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "limitCount",
                                              $$v
                                            )
                                          },
                                          expression: "form.limitCount",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "limit-label" },
                                        [_vm._v("张")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "limit-divider" }),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "limit-radio",
                                      attrs: { label: 2 },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "limit-label" },
                                        [_vm._v("每人每天限领")]
                                      ),
                                      _vm._v(" "),
                                      _c("el-input-number", {
                                        staticClass: "limit-input",
                                        attrs: {
                                          min: 1,
                                          max: 999,
                                          size: "small",
                                          "controls-position": "right",
                                        },
                                        model: {
                                          value: _vm.form.limitDailyCount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "limitDailyCount",
                                              $$v
                                            )
                                          },
                                          expression: "form.limitDailyCount",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "limit-label" },
                                        [_vm._v("张")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "是否公开：", prop: "isPublic" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.isPublic,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isPublic", $$v)
                                },
                                expression: "form.isPublic",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("公开"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不公开"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "领用后跳转页面：",
                            prop: "redeemPageUrl",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入领用后的跳转页面URL",
                            },
                            model: {
                              value: _vm.form.redeemPageUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "redeemPageUrl", $$v)
                              },
                              expression: "form.redeemPageUrl",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "适用分销客户：",
                            prop: "distributionCustomers",
                          },
                        },
                        [
                          _c("div", { staticClass: "multi-select-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "select-header" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "multi-select",
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      multiple: "",
                                      filterable: "",
                                      clearable:
                                        _vm.form.isIntegralExchange !== 1,
                                      "collapse-tags": "",
                                      placeholder:
                                        "请选择适用分销客户（支持搜索、可多选）",
                                      "max-collapse-tags": 3,
                                      disabled:
                                        _vm.form.isIntegralExchange === 1,
                                    },
                                    model: {
                                      value: _vm.form.distributionCustomers,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "distributionCustomers",
                                          $$v
                                        )
                                      },
                                      expression: "form.distributionCustomers",
                                    },
                                  },
                                  _vm._l(
                                    _vm.commonData.distributionCustomers,
                                    function (item) {
                                      return _c(
                                        "el-option",
                                        {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.name)),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                float: "right",
                                                color: "#8492a6",
                                                "font-size": "12px",
                                              },
                                            },
                                            [_vm._v("ID: " + _vm._s(item.id))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                                _vm._v(" "),
                                _vm.form.isIntegralExchange !== 1
                                  ? _c(
                                      "div",
                                      { staticClass: "select-actions" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "action-btn",
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: _vm.selectAllCustomers,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  全选\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "action-btn",
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: _vm.clearAllCustomers,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  清空\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.form.isIntegralExchange === 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-tip",
                                    staticStyle: { "margin-bottom": "8px" },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-info" }),
                                    _vm._v(
                                      " 积分兑换默认选择全部分销客户，且不支持切换\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.distributionCustomers &&
                            _vm.form.distributionCustomers.length > 0
                              ? _c("div", { staticClass: "selected-info" }, [
                                  _c("i", {
                                    staticClass: "el-icon-check",
                                    staticStyle: {
                                      color: "#67C23A",
                                      "margin-right": "4px",
                                    },
                                  }),
                                  _vm._v("\n              已选择 "),
                                  _c(
                                    "strong",
                                    { staticStyle: { color: "#667eea" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.form.distributionCustomers.length
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" 个客户\n              "),
                                  _vm.commonData.distributionCustomers &&
                                  _vm.commonData.distributionCustomers.length
                                    ? _c(
                                        "span",
                                        { staticClass: "selected-detail" },
                                        [
                                          _vm._v(
                                            "（共 " +
                                              _vm._s(
                                                _vm.commonData
                                                  .distributionCustomers.length
                                              ) +
                                              " 个可选）"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "可使用场景：", prop: "usableScenarios" },
                    },
                    [
                      _c("div", { staticClass: "multi-select-wrapper" }, [
                        _c(
                          "div",
                          { staticClass: "select-header" },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "multi-select",
                                staticStyle: { flex: "1" },
                                attrs: {
                                  multiple: "",
                                  filterable: "",
                                  clearable: "",
                                  "collapse-tags": "",
                                  placeholder:
                                    "请选择可使用场景（支持搜索、可多选）",
                                  "max-collapse-tags": 3,
                                },
                                on: { change: _vm.handleUsableScenariosChange },
                                model: {
                                  value: _vm.form.usableScenarios,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "usableScenarios", $$v)
                                  },
                                  expression: "form.usableScenarios",
                                },
                              },
                              _vm._l(
                                _vm.availableProductTypeOptions,
                                function (item) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: item.code,
                                      attrs: {
                                        label: item.value,
                                        value: item.code,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.value) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select-actions" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "action-btn",
                                    attrs: { type: "text", size: "small" },
                                    on: { click: _vm.selectAllScenarios },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  全选\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "action-btn",
                                    attrs: { type: "text", size: "small" },
                                    on: { click: _vm.clearAllScenarios },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  清空\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.usableScenarios &&
                        _vm.form.usableScenarios.length > 0
                          ? _c("div", { staticClass: "selected-info" }, [
                              _c("i", {
                                staticClass: "el-icon-check",
                                staticStyle: {
                                  color: "#67C23A",
                                  "margin-right": "4px",
                                },
                              }),
                              _vm._v("\n              已选择 "),
                              _c(
                                "strong",
                                { staticStyle: { color: "#667eea" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.form.usableScenarios.length)
                                  ),
                                ]
                              ),
                              _vm._v(" 个场景\n              "),
                              _vm.availableProductTypeOptions.length
                                ? _c(
                                    "span",
                                    { staticClass: "selected-detail" },
                                    [
                                      _vm._v(
                                        "（共 " +
                                          _vm._s(
                                            _vm.availableProductTypeOptions
                                              .length
                                          ) +
                                          " 个可选）"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "关联券包：", prop: "packageIds" } },
                        [
                          _c(
                            "div",
                            { staticClass: "package-selector" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    multiple: "",
                                    "collapse-tags": "",
                                    placeholder: "请选择券包（可多选）",
                                    loading: _vm.packageLoading,
                                    "filter-method": _vm.handlePackageSearch,
                                  },
                                  model: {
                                    value: _vm.form.packageIds,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "packageIds", $$v)
                                    },
                                    expression: "form.packageIds",
                                  },
                                },
                                [
                                  _vm._l(_vm.packageOptions, function (item) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      },
                                      [
                                        _c("span", [_vm._v(_vm._s(item.name))]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              float: "right",
                                              color: "#8492a6",
                                              "font-size": "13px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.couponCount) + "张券"
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.packageOptions.length < _vm.packageTotal
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "load-more-option",
                                          on: { click: _vm.loadMorePackages },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-plus",
                                          }),
                                          _vm._v(
                                            " 加载更多券包\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "package-actions" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        disabled:
                                          !_vm.form.packageIds ||
                                          _vm.form.packageIds.length === 0,
                                        icon: "el-icon-view",
                                      },
                                      on: { click: _vm.viewPackageDetails },
                                    },
                                    [
                                      _vm._v(
                                        "\n                查看已选券包\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否需实名认证：",
                            prop: "requireRealNameAuth",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.requireRealNameAuth,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "requireRealNameAuth", $$v)
                                },
                                expression: "form.requireRealNameAuth",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon &&
                  _vm.form.requireRealNameAuth === 1 &&
                  _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "实名认证次数限制：",
                            prop: "realNameAuthLimit",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              min: 1,
                              max: 9999,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.realNameAuthLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "realNameAuthLimit", $$v)
                              },
                              expression: "form.realNameAuthLimit",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "input-suffix",
                              staticStyle: { "margin-left": "8px" },
                            },
                            [_vm._v("次/天")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-tip",
                              staticStyle: { "margin-top": "8px" },
                            },
                            [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                " 仅在“是否需实名认证”开启时生效，示例：填写 3 表示每个用户每日最多调用实名认证 3 次；留空表示使用系统默认限制。\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否地区限制：",
                            prop: "isAreaRestricted",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleAreaRestrictedChange },
                              model: {
                                value: _vm.form.isAreaRestricted,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isAreaRestricted", $$v)
                                },
                                expression: "form.isAreaRestricted",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "启用验证码：",
                            prop: "enableCaptcha",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.enableCaptcha,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "enableCaptcha", $$v)
                                },
                                expression: "form.enableCaptcha",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-tip",
                              staticStyle: { "margin-top": "8px" },
                            },
                            [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                " 开启后，用户领取优惠券时需要输入验证码\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "启用参数加密：",
                            prop: "enableParamEncryption",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.enableParamEncryption,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "enableParamEncryption",
                                    $$v
                                  )
                                },
                                expression: "form.enableParamEncryption",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-tip",
                              staticStyle: { "margin-top": "8px" },
                            },
                            [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                " 开启后，用户端请求领取接口时需对请求参数进行加密\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "启用压测模式：",
                            prop: "enableStressTest",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.enableStressTest,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "enableStressTest", $$v)
                                },
                                expression: "form.enableStressTest",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-tip",
                              staticStyle: { "margin-top": "8px" },
                            },
                            [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                " 开启后，领取接口会使用随机 userId（用于压测）\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "启用限流：",
                            prop: "enableRateLimit",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleRateLimitChange },
                              model: {
                                value: _vm.form.enableRateLimit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "enableRateLimit", $$v)
                                },
                                expression: "form.enableRateLimit",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-tip",
                              staticStyle: { "margin-top": "8px" },
                            },
                            [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                " 开启后，将对领取接口进行限流保护，防止恶意刷券\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon &&
                  _vm.form.enableRateLimit === 1 &&
                  _vm.form.isIntegralExchange !== 1
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "全局限流：",
                              prop: "globalRateLimit",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                min: 1,
                                max: 10000,
                                precision: 0,
                                "controls-position": "right",
                              },
                              model: {
                                value: _vm.form.globalRateLimit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "globalRateLimit", $$v)
                                },
                                expression: "form.globalRateLimit",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "input-suffix",
                                staticStyle: { "margin-left": "8px" },
                              },
                              [_vm._v("次/秒")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-tip",
                                staticStyle: { "margin-top": "8px" },
                              },
                              [
                                _c("i", { staticClass: "el-icon-info" }),
                                _vm._v(
                                  " 该优惠券每秒允许的最大请求数，建议值：100-1000\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "用户级限流：",
                              prop: "userRateLimit",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                min: 1,
                                max: 1000,
                                precision: 0,
                                "controls-position": "right",
                              },
                              model: {
                                value: _vm.form.userRateLimit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "userRateLimit", $$v)
                                },
                                expression: "form.userRateLimit",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "input-suffix",
                                staticStyle: { "margin-left": "8px" },
                              },
                              [_vm._v("次/秒")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-tip",
                                staticStyle: { "margin-top": "8px" },
                              },
                              [
                                _c("i", { staticClass: "el-icon-info" }),
                                _vm._v(
                                  " 每个用户对该优惠券每秒允许的最大请求数，建议值：1-10\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "限流时间窗口：",
                              prop: "rateLimitWindowSeconds",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                min: 1,
                                max: 60,
                                precision: 0,
                                "controls-position": "right",
                              },
                              model: {
                                value: _vm.form.rateLimitWindowSeconds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "rateLimitWindowSeconds",
                                    $$v
                                  )
                                },
                                expression: "form.rateLimitWindowSeconds",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "input-suffix",
                                staticStyle: { "margin-left": "8px" },
                              },
                              [_vm._v("秒")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-tip",
                                staticStyle: { "margin-top": "8px" },
                              },
                              [
                                _c("i", { staticClass: "el-icon-info" }),
                                _vm._v(
                                  " 限流统计的时间窗口，默认1秒\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isAreaRestricted === 1
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "area-restriction-item",
                          attrs: {
                            label: "地区限制范围：",
                            prop: "areaRestrictionScope",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "area-selector-container" },
                            [
                              _c("el-cascader", {
                                staticClass: "area-restriction-cascader",
                                staticStyle: {
                                  width: "100%",
                                  "max-width": "600px",
                                },
                                attrs: {
                                  options: _vm.addressData,
                                  props: {
                                    value: "name",
                                    label: "name",
                                    children: "child",
                                    expandTrigger: "hover",
                                    multiple: true,
                                    emitPath: true,
                                  },
                                  filterable: "",
                                  clearable: "",
                                  "collapse-tags": "",
                                  placeholder: "请选择省市区(县)，支持搜索",
                                  "show-all-levels": false,
                                  "popper-class": "area-cascader-popper",
                                  "append-to-body": true,
                                },
                                on: { change: _vm.handleAreaChange },
                                model: {
                                  value: _vm.areaRestrictionScopeArray,
                                  callback: function ($$v) {
                                    _vm.areaRestrictionScopeArray = $$v
                                  },
                                  expression: "areaRestrictionScopeArray",
                                },
                              }),
                              _vm._v(" "),
                              _vm.areaRestrictionScopeList &&
                              _vm.areaRestrictionScopeList.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "area-tips-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "selected-areas" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selected-areas-header",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-location-information",
                                              }),
                                              _vm._v(
                                                "\n                    已选择 "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.areaRestrictionScopeList
                                                      .length
                                                  )
                                                ),
                                              ]),
                                              _vm._v(
                                                " 个地区：\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selected-areas-tags",
                                            },
                                            _vm._l(
                                              _vm.areaRestrictionScopeList,
                                              function (areaPath, index) {
                                                return _c(
                                                  "el-tag",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      closable: "",
                                                      type: "info",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      close: function ($event) {
                                                        return _vm.removeArea(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(areaPath) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isAreaRestricted === 1
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "polygon-boundary-item",
                          attrs: {
                            label: "多边形边界坐标：",
                            prop: "polygonBoundary",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "polygon-boundary-container" },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "100%",
                                  "max-width": "600px",
                                },
                                attrs: {
                                  type: "textarea",
                                  rows: 10,
                                  placeholder:
                                    "请输入多边形边界坐标点（JSON格式），格式示例：&#10;[[103.53354, 29.860657], [103.532466, 29.865222], [103.531021, 29.866436]]&#10;&#10;说明：&#10;1. 每个坐标点格式：[经度, 纬度]&#10;2. 至少需要3个坐标点才能形成多边形&#10;3. 经度范围：-180 ~ 180&#10;4. 纬度范围：-90 ~ 90&#10;5. 最后一个点会自动与第一个点连接形成闭合多边形",
                                },
                                on: { blur: _vm.validatePolygonBoundary },
                                model: {
                                  value: _vm.form.polygonBoundary,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "polygonBoundary", $$v)
                                  },
                                  expression: "form.polygonBoundary",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "polygon-tips" },
                                [
                                  _c("el-alert", {
                                    staticStyle: { "margin-top": "10px" },
                                    attrs: {
                                      title:
                                        "提示：如果配置了多边形坐标点，系统将使用精确的地理围栏校验；如果未配置，将使用默认的洪雅市边界",
                                      type: "info",
                                      closable: false,
                                      "show-icon": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.polygonBoundaryValidation.isValid === true
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "validation-success",
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-circle-check",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "坐标点格式验证通过（共 " +
                                                _vm._s(
                                                  _vm.polygonBoundaryValidation
                                                    .pointCount
                                                ) +
                                                " 个点）"
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm.polygonBoundaryValidation.isValid ===
                                      false
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "validation-error",
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-circle-close",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.polygonBoundaryValidation
                                                  .errorMessage
                                              )
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否与福利卡互斥：",
                            prop: "excludeWelfareCard",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: _vm.handleExcludeWelfareCardChange,
                              },
                              model: {
                                value: _vm.form.excludeWelfareCard,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "excludeWelfareCard", $$v)
                                },
                                expression: "form.excludeWelfareCard",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.excludeWelfareCard === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "选择福卡：",
                            prop: "excludeWelfareCardIds",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择需互斥的福卡（可搜索）",
                                loading: _vm.welfareCardLoading,
                              },
                              on: {
                                "visible-change": function (val) {
                                  return val && _vm.loadWelfareCardOptions()
                                },
                              },
                              model: {
                                value: _vm.form.excludeWelfareCardIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "excludeWelfareCardIds",
                                    $$v
                                  )
                                },
                                expression: "form.excludeWelfareCardIds",
                              },
                            },
                            _vm._l(_vm.welfareCardOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否与其他优惠互斥：",
                            prop: "excludeOtherDiscounts",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.excludeOtherDiscounts,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "excludeOtherDiscounts",
                                    $$v
                                  )
                                },
                                expression: "form.excludeOtherDiscounts",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "优惠券标签：", prop: "couponTag" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              placeholder: "请输入优惠券标签（不超过5个字）",
                              maxlength: "5",
                              "show-word-limit": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.couponTag,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "couponTag", $$v)
                              },
                              expression: "form.couponTag",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.isIntegralExchange !== 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "地区验证失败提示语：",
                            prop: "areaValidationFailMsg",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "500px" },
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              placeholder:
                                "请输入地区验证失败时的提示语（1-50字）",
                              maxlength: "50",
                              "show-word-limit": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.areaValidationFailMsg,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "areaValidationFailMsg", $$v)
                              },
                              expression: "form.areaValidationFailMsg",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 2,
                      expression: "currentStep === 2",
                    },
                  ],
                  staticClass: "form-card",
                },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _c("i", { staticClass: "el-icon-setting" }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("范围配置")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-divider" }),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon &&
                  _vm.form.usableScenarios &&
                  _vm.form.usableScenarios.includes(1)
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "applicableRangeType",
                            label: "实物商品配置：",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "range-config-item" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择（支持搜索）",
                                  },
                                  on: { change: _vm.changeApplicableRangeType },
                                  model: {
                                    value: _vm.form.applicableRangeType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "applicableRangeType",
                                        $$v
                                      )
                                    },
                                    expression: "form.applicableRangeType",
                                  },
                                },
                                _vm._l(
                                  _vm.couponEnum.useGoodsEnum,
                                  function (opt) {
                                    return _c("el-option", {
                                      key: opt.value,
                                      attrs: {
                                        label: opt.label,
                                        value: opt.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                              _vm._v(" "),
                              [2, 3].includes(_vm.form.applicableRangeType)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btns",
                                      staticStyle: { "margin-left": "10px" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            icon: "el-icon-plus",
                                          },
                                          on: { click: _vm.goSelectGoods },
                                        },
                                        [_vm._v("选择商品")]
                                      ),
                                      _vm._v(" "),
                                      _c("CouponProductsImport", {
                                        attrs: {
                                          currentProducts:
                                            _vm.applicableProducts,
                                          onSuccess: _vm.handleImportSuccess,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon && _vm.form.applicableRangeType == 4
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "选择分类" } },
                        [
                          _c("el-cascader", {
                            staticClass: "category-cascader",
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择（支持搜索）",
                              options: _vm.commonData.showCateIdOption,
                              props: {
                                children: "child",
                                label: "name",
                                value: "id",
                                multiple: true,
                              },
                              filterable: "",
                              clearable: "",
                              "collapse-tags": "",
                            },
                            model: {
                              value: _vm.form.cateIdList,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cateIdList", $$v)
                              },
                              expression: "form.cateIdList",
                            },
                          }),
                        ],
                        1
                      )
                    : !_vm.isMerchantCoupon &&
                      [2, 3].includes(_vm.form.applicableRangeType)
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "product-table-container",
                          attrs: { label: "选择商品" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "show-goods" },
                            [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.showTableData.list,
                                    border: "",
                                    stripe: "",
                                    "header-cell-style": {
                                      backgroundColor: "#f5f7fa",
                                    },
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "ID",
                                      prop: "id",
                                      align: "center",
                                      width: "100",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "编码",
                                      prop: "skuCode",
                                      align: "center",
                                      width: "150",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "名称",
                                      prop: "skuName",
                                      align: "center",
                                      "min-width": "100",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "零售价",
                                      prop: "otPrice",
                                      align: "center",
                                      width: "100",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "状态",
                                      prop: "listStatus",
                                      align: "center",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type:
                                                    scope.row.listStatus == 1
                                                      ? "success"
                                                      : "danger",
                                                  size: "small",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      {
                                                        0: "未上架",
                                                        1: "已上架",
                                                      }[scope.row.listStatus]
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "品牌",
                                      prop: "brandName",
                                      align: "center",
                                      width: "100",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "供应商",
                                      prop: "supplierName",
                                      align: "center",
                                      width: "200",
                                      "show-overflow-tooltip": "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "操作",
                                      align: "center",
                                      width: "100",
                                      fixed: "right",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  icon: "el-icon-delete",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeGoods(
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("移除")]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("el-pagination", {
                                staticStyle: {
                                  "text-align": "right",
                                  "margin-top": "15px",
                                },
                                attrs: {
                                  "page-sizes": [20, 40, 60, 80],
                                  "page-size": _vm.pageData.limit,
                                  "current-page": _vm.pageData.page,
                                  layout:
                                    "total, sizes, prev, pager, next, jumper",
                                  total: _vm.showTableData.total,
                                  background: "",
                                },
                                on: {
                                  "size-change": _vm.handleSizeChange,
                                  "current-change": _vm.handleCurrentChange,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "自营卡券商品：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: "可多选（支持搜索）",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.selfOperatedCardVouchers,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "selfOperatedCardVouchers",
                                    $$v
                                  )
                                },
                                expression: "form.selfOperatedCardVouchers",
                              },
                            },
                            _vm._l(_vm.cardVoucherOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "在线点餐：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: "可多选品牌（支持搜索）",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.onlineOrderingBrands,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "onlineOrderingBrands",
                                    $$v
                                  )
                                },
                                expression: "form.onlineOrderingBrands",
                              },
                            },
                            _vm._l(_vm.brandOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c("el-form-item", { attrs: { label: "核销门店：" } }, [
                        _c(
                          "div",
                          { staticClass: "range-config-item" },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  multiple: "",
                                  filterable: "",
                                  placeholder: "可多选商家（支持搜索）",
                                  clearable: "",
                                },
                                on: {
                                  change: _vm.handleVerificationMerchantsChange,
                                },
                                model: {
                                  value: _vm.form.verificationStoresMerchants,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "verificationStoresMerchants",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.verificationStoresMerchants",
                                },
                              },
                              _vm._l(_vm.merchantOptions, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  width: "250px",
                                  "margin-left": "10px",
                                },
                                attrs: {
                                  multiple: "",
                                  filterable: "",
                                  placeholder: "可多选门店（支持搜索）",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.verificationStores,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "verificationStores",
                                      $$v
                                    )
                                  },
                                  expression: "form.verificationStores",
                                },
                              },
                              _vm._l(_vm.storeOptions, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-tip",
                            staticStyle: { "margin-top": "8px" },
                          },
                          [
                            _c("i", { staticClass: "el-icon-info" }),
                            _vm._v(
                              " 选中商家时，默认选中该商家下所有门店\n          "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMerchantCoupon
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "加油门店：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                remote: "",
                                "remote-method": _vm.handleGasStationSearch,
                                loading: _vm.gasStationLoading,
                                placeholder: "可多选门店（支持搜索）",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.gasStationStores,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "gasStationStores", $$v)
                                },
                                expression: "form.gasStationStores",
                              },
                            },
                            _vm._l(_vm.gasStationOptions, function (item) {
                              return _c(
                                "el-option",
                                {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(item.name))]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        float: "right",
                                        color: "#8492a6",
                                        "font-size": "12px",
                                      },
                                    },
                                    [_vm._v("编码: " + _vm._s(item.id))]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "多商户商家：" } }, [
                    _c(
                      "div",
                      { staticClass: "range-config-item" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "250px" },
                            attrs: {
                              multiple: "",
                              filterable: "",
                              placeholder: "可多选商家（支持搜索）",
                              clearable: !_vm.isMerchantCoupon,
                              disabled: _vm.isMerchantCoupon,
                            },
                            on: { change: _vm.handleRenshouMerchantsChange },
                            model: {
                              value: _vm.form.renshouMerchants,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "renshouMerchants", $$v)
                              },
                              expression: "form.renshouMerchants",
                            },
                          },
                          _vm._l(_vm.renshouMerchantOptions, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "250px",
                              "margin-left": "10px",
                            },
                            attrs: {
                              multiple: "",
                              filterable: "",
                              placeholder: "可多选门店（仅网店，支持搜索）",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.renshouStores,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "renshouStores", $$v)
                              },
                              expression: "form.renshouStores",
                            },
                          },
                          _vm._l(_vm.renshouStoreOptions, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-tip",
                        staticStyle: { "margin-top": "8px" },
                      },
                      [
                        _c("i", { staticClass: "el-icon-info" }),
                        _vm._v(
                          " 选中商家时，默认选中该商家下所有门店；只能选择网店类型的门店\n          "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === 3,
                      expression: "currentStep === 3",
                    },
                  ],
                  staticClass: "form-card",
                },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _c("i", { staticClass: "el-icon-document" }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("使用说明")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-divider" }),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "使用须知：" } },
                    [
                      _c("Tinymce", {
                        ref: "applicableNoticeEditor",
                        attrs: { height: 300, sourceType: "coupon" },
                        model: {
                          value: _vm.form.applicableNotice,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applicableNotice", $$v)
                          },
                          expression: "form.applicableNotice",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "使用范围：" } },
                    [
                      _c("Tinymce", {
                        ref: "applicableScopeEditor",
                        attrs: { height: 300, sourceType: "coupon" },
                        model: {
                          value: _vm.form.applicableScope,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applicableScope", $$v)
                          },
                          expression: "form.applicableScope",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("SelectGoodsVue", {
            ref: "selectGoodsVueRef",
            on: { updateTableData: _vm.updateTableData },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _vm.currentStep > 0
            ? _c(
                "el-button",
                {
                  attrs: { disabled: _vm.loading },
                  on: { click: _vm.prevStep },
                },
                [_vm._v("上一步")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep < _vm.steps.length - 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.nextStep },
                },
                [_vm._v("下一步")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                icon: "el-icon-check",
                loading: _vm.loading,
              },
              on: { click: _vm.submitForm },
            },
            [_vm._v("提交")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "info",
                icon: "el-icon-back",
                loading: _vm.loading,
              },
              on: { click: _vm.close },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }